import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/about-us.jpg";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Who we are"
				subtitle=""
				breadcrumbText="Who we are"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}